export default __webpack_public_path__ + "static/media/melanau_icon.1020bdda.png";